module.exports = __webpack_public_path__ + "media/images/indicators/perdas-94d70eda93d99cdca7c8ee7b0968b334.png";